<template>
  <div class="placeholder-page center">
    <img width="160px" :src="require('@/assets/imgs/' + placeholderImg + '.png')" alt="" />
    <slot>
      <p class="text">{{ placeholderText }}</p>
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    placeholderImg: {
      type: String,
      default: 'list-empty'
    },
    placeholderText: {
      type: String,
      default: '暂无数据'
    }
  }
};
</script>

<style lang="less">
.placeholder-page {
  text-align: center;
  margin-top: 96px;
  .text {
    color: @gray-7;
    line-height: 22px;
    margin-top: 0;
  }
}
</style>
